import { useEffect } from "react";
import { fetchCoupons } from "../actions/coupons";

import { PublicityBanner, IPublicityBannerProps } from "@gisce/oficina-virtual-components";
import useI18n from "@/hooks/useI18n";
import { useAppDispatch, useAppSelector } from "@/hooks";

export const CouponsView = () => {
  const dispatch = useAppDispatch();
  const { currentLang } = useI18n();
  const isAuthenticated = useAppSelector(store => store.auth.isAuthenticated);
  const coupons: IPublicityBannerProps["dataProps"][] = useAppSelector(state => state.coupons.data);
  const fetching: boolean = useAppSelector(state => state.coupons.fetching);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchCoupons(currentLang.value));
    }
  }, [isAuthenticated, currentLang.value]); 

  return !fetching && coupons && Array.isArray(coupons) && <>
      {coupons.map((coupon, idx) => <PublicityBanner dataProps={coupon} key={idx}/>)}
    </>
};
